import { AssetPosition, DisplayOrientation } from '@fdc/types/asset';

import { FeatureTile } from '../feature-tile/feature-tile';

import { FeatureTileListProps } from './feature-tile-list-model';
import styles from './feature-tile-list.module.scss';

const getImagePosition = (
  displayOrientation: DisplayOrientation,
  imagePosition: AssetPosition
): AssetPosition => {
  if (displayOrientation === DisplayOrientation.HORIZONTAL) {
    return AssetPosition.TOP;
  }

  return imagePosition;
};

export const FeatureTileList: React.FC<FeatureTileListProps> = ({
  displayOrientation,
  items,
  sectionId,
}) => {
  const directionClass =
    displayOrientation === DisplayOrientation.HORIZONTAL ? 'row' : 'column';

  return (
    <section
      id={sectionId}
      data-testid={sectionId}
      className={`${styles.featureTileList} ${directionClass}`}
    >
      {items.map((item, index) => (
        <FeatureTile
          key={item.heading + index}
          image={item.image}
          imageMobile={item.imageMobile}
          imageAltText={item.imageAltText}
          imagePosition={getImagePosition(
            displayOrientation,
            item.imagePosition
          )}
          heading={item.heading}
          body={item.body}
          buttonLabel={item.buttonLabel}
          btnClickHandler={item.btnClickHandler}
          buttonAltText={item.buttonAltText}
        />
      ))}
    </section>
  );
};
